import { render, staticRenderFns } from "./user.vue?vue&type=template&id=1979d66e&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"
import style0 from "./user.vue?vue&type=style&index=0&id=1979d66e&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979d66e",
  null
  
)

export default component.exports